<div class="d-flex mb-1">
  @if (!attribute.isAttributeSelectionDisabled) {
    <ix-checkbox
      class="bp-form-select-position mb-1"
      id="cb_{{ attribute.name }}"
      label="{{ attribute.translation.label | translate }}"
      (checkedChange)="onSelectionChange(attribute.valuePath,$event)"
      [checked]="isAttributeSelected(attribute.valuePath)"
    [disabled]="isAttributeDisabled(attribute.valuePath) || 
      attribute.isAttributeSelectionDisabled !== undefined ? 
      attribute.isAttributeSelectionDisabled : 
      false"
      />
  }
  @if (attribute.isAttributeSelectionDisabled) {
    <ix-typography>
      {{ attribute.translation.label | translate }}
    </ix-typography>
  }
  @if (attribute && attribute.translation && attribute.translation.info) {
    <ix-icon (click)="showInfo = !showInfo" class="ms-2 info-icon"
      id="info_{{attribute.name}}"
    name="question" onkeypress="" size="16"></ix-icon>
    <ix-tooltip
      for="#info_{{attribute.name}}"
      id="info_{{attribute.name}}_tooltip">
      {{ attribute.translation.info | translate }}
    </ix-tooltip>
  }
  @if (attribute.isRequired) {
    <ix-typography
      class="d-inline"
      format="label"
      id="label_mandatory_{{ attribute.name }}"
      textColor="alarm"
      >&nbsp;*
    </ix-typography>
  }
  <ix-tooltip for="#label_mandatory_{{ attribute.name }}"
    id="label_mandatory_{{ attribute.name }}_tooltip">
    {{ 'battery_pass.create.mandatory_attribute' | translate }}
  </ix-tooltip>
</div>
